import Icon from '../icons/Icon';
import iconsList from '../icons/iconsList';
import classes from './DayClock.module.css';

const DayClock = ({ label, date, icon, color = '#000', showDate = true, className }) => {
    const hasValidDate = Boolean(date) && !Number.isNaN(new Date(date).getTime());
    const daysLeft = hasValidDate
        ? Math.ceil((new Date(date) - new Date()) / (1000 * 60 * 60 * 24))
        : null;

    return (
        <div className={`${classes.Clock} ${className || ''}`}>
            <div className={`${classes.Timer} ${icon ? classes.TimerWithIcon : classes.TimerWithoutIcon}`}>
                <div className={`${classes.TimerShape} ${icon ? classes.TimerShapeWithIcon : classes.TimerShapeWithoutIcon}`}>
                    <Icon
                        name={iconsList.timer}
                        color={color}
                        width="100%"
                        height="100%"
                    />
                </div>
                <div className={classes.TimerContent}>
                    <div className={classes.DaysLeft} style={{ color }}>
                        {daysLeft}
                    </div>
                    {icon &&
                        <Icon
                            name={icon}
                            color={color}
                            size={31}
                            className={classes.EventIcon}
                        />
                    }
                    <div className={classes.Label} style={{ color }}>
                        {label}
                    </div>
                </div>
            </div>
            {showDate && hasValidDate &&
                <div className={classes.Date}>
                    <Icon
                        name={iconsList.calendarWithoutNumbers}
                        color="#000"
                        width="15.913px"
                        height="16.552px"
                    />
                    <div className={classes.DateText}>
                        {new Date(date).toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: '2-digit' })}
                    </div>
                </div>
            }
        </div>
    );
};

export default DayClock;
